/**
 * Gift Combo Popup - SIMPLIFIED & GUARANTEED TO WORK
 * CURRENTLY DISABLED - Using Special Add-ons popup instead
 */

(function() {
  console.log('🎁🎁🎁 GIFT COMBO LOADING... (DISABLED)');

  // DISABLED - Gift combo popup is hidden, so don't run any logic
  const DISABLED = true;

  if (DISABLED) {
    console.log('⏸️ Gift Combo Popup is disabled');
    return;
  }

  let popup = null;
  let shown = false;
  let origFetch = window.fetch;

  // Initialize
  function init() {
    popup = document.getElementById('giftComboPopup');

    if (!popup) {
      console.error('❌❌❌ POPUP NOT FOUND!');
      setTimeout(init, 1000);
      return;
    }

    console.log('✅✅✅ POPUP FOUND!');

    // Setup overlay click
    let overlay = popup.querySelector('.gift-combo-overlay');
    if (overlay) overlay.onclick = close;

    // Intercept fetch
    window.fetch = async function(...args) {
      let url = args[0];
      let res = await origFetch.apply(this, args);

      if (url && url.toString().includes('/cart/add')) {
        console.log('🎯🎯🎯 CART ADD DETECTED!');
        setTimeout(show, 50);
      }

      return res;
    };

    // Watch for cart drawer
    new MutationObserver((muts) => {
      muts.forEach(m => {
        m.addedNodes.forEach(n => {
          if (n.id === 'cart-notification' || n.id === 'cart-drawer') {
            console.log('🎯🎯🎯 CART DRAWER DETECTED!');
            setTimeout(show, 100);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });

    console.log('✅✅✅ ALL LISTENERS READY!');
  }

  // Show popup
  function show() {
    if (!popup) {
      console.error('❌ Cannot show - no popup');
      return;
    }

    if (shown) {
      console.log('⏭️ Already shown');
      return;
    }

    console.log('🎉🎉🎉 SHOWING POPUP!!!');

    popup.classList.add('active');
    popup.classList.add('visible');
    document.body.style.overflow = 'hidden';
    shown = true;
    sessionStorage.setItem('giftComboPopupShown', 'true');
  }

  // Close popup
  function close() {
    console.log('❌ Closing popup');
    if (!popup) return;

    popup.classList.remove('visible');
    setTimeout(() => popup.classList.remove('active'), 400);
    document.body.style.overflow = '';
  }

  // Accept offer
  async function accept() {
    console.log('✅ User accepted!');
    let btn = popup.querySelector('.gift-combo-btn-primary');
    if (btn) btn.innerHTML = 'Adding...';

    try {
      let prodRes = await origFetch('/products/complete-gift-combo.js');
      let prod = await prodRes.json();
      let variant = prod.variants[0];

      // Add combo to cart (quantity: 1, keeps original product)
      await origFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      });

      if (btn) btn.innerHTML = '✅ Added to Cart!';

      console.log('✅ Combo added! Opening cart drawer...');

      // Close popup after short delay
      setTimeout(() => {
        close();

        // Try to open cart drawer - multiple methods for compatibility
        // Method 1: Theme's cart drawer function
        if (window.theme && window.theme.openCartDrawer) {
          window.theme.openCartDrawer();
        }
        // Method 2: Common cart drawer toggle
        else if (window.CartDrawer && window.CartDrawer.open) {
          window.CartDrawer.open();
        }
        // Method 3: Click cart icon to open drawer
        else {
          const cartIcon = document.querySelector('[data-cart-drawer], [data-cart-notification-toggle], .js-drawer-open-cart');
          if (cartIcon) {
            cartIcon.click();
          } else {
            // Method 4: Dispatch custom event for theme to listen
            document.dispatchEvent(new CustomEvent('cart:open'));

            // Method 5: If all else fails, refresh to show updated cart
            console.log('⚠️ Could not open cart drawer, refreshing page');
            setTimeout(() => location.reload(), 500);
          }
        }
      }, 800);

    } catch (err) {
      console.error('❌ Error:', err);
      if (btn) btn.innerHTML = '❌ Error!';
      setTimeout(() => {
        if (btn) btn.innerHTML = 'Upgrade to Combo';
      }, 2000);
    }
  }

  // Manual trigger
  function trigger() {
    shown = false;
    sessionStorage.removeItem('giftComboPopupShown');
    show();
  }

  // Expose
  window.giftComboPopup = { close, acceptOffer: accept };
  window.giftComboPopupManager = { manualTrigger: trigger, resetSession: () => {
    shown = false;
    sessionStorage.removeItem('giftComboPopupShown');
  }};

  // Start
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  console.log('✅✅✅ SCRIPT LOADED!');
})();
